import { BoxSpg, FormSection, GridContainer, GridItem, InputFormField } from "@duosoftbg/nacid-components";
import React from "react";

const AccountFormSection = ({ isPublicSection = true }) => {
  return (
    <FormSection label={"t.registration.details"}>
      <GridContainer>
        <GridItem md={4}>
          <BoxSpg style={{ whiteSpace: "pre-line" }}>
            <InputFormField
              required={true}
              fieldName={"username"}
              labelCode={"l.user.username"}
              isDisabled={!isPublicSection}
            />
          </BoxSpg>
        </GridItem>
        <GridItem md={4}>
          <InputFormField required={true} fieldName={"email"} labelCode={"l.person.email"} />
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem md={4}>
          <BoxSpg style={{ whiteSpace: "pre-line" }}>
            <InputFormField
              required={isPublicSection}
              type={"password"}
              fieldName={"password"}
              labelCode={"l.user.password"}
            />
          </BoxSpg>
        </GridItem>
        {isPublicSection && (
          <GridItem md={4}>
            <InputFormField
              required={true}
              type={"password"}
              fieldName={"confirmPassword"}
              labelCode={"l.user.confirmPassword"}
            />
          </GridItem>
        )}
      </GridContainer>
    </FormSection>
  );
};
export default AccountFormSection;
